/**
 * @module
 * @format
 */

import {BOOLEAN, INTEGER, NULLABLE, OBJECT, STRING} from '@acng/frontend-rubicon';
import {FSK_LEVEL} from './fsk.js';

const asPortalData = /* @__PURE__ */ OBJECT({
  id: INTEGER,
  name: STRING,
  abbr: STRING,
  shortcut: STRING,
  mobile: BOOLEAN,
  niche: STRING,
  list_sorting_suffix: STRING,
  is_international: BOOLEAN,
  email: /* @__PURE__ */ OBJECT({
    support: STRING,
    compliance: STRING,
  }),
  link: /* @__PURE__ */ OBJECT({
    creator: STRING,
    webmaster: NULLABLE(STRING),
  }),
  guest_fsk: FSK_LEVEL,
  list_base_fsk: FSK_LEVEL,
  copyrightNotice: STRING,
  script: /* @__PURE__ */ OBJECT({
    matomo: /* @__PURE__ */ NULLABLE(STRING),
  }),
});

export {asPortalData};
